import { Box, Button, Typography } from '@mui/material';
import React from 'react';
import { ColorPalette } from '../components/config/color-palette';
import { configuration } from '../configuration';

// the STS's own logged-out page (Fasit.STS/Views/Logout/LoggedOut.cshtml) looks the same, so both read as one logout
const fontFamily = '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif';

/**
 * Where a tab lands when the fasit session was logged out somewhere else. It does not log in again by itself: every open
 * tab lands here at once, and each would start its own login.
 */
export function LoggedOut() {
  return (
    // fixed to the viewport, so the margins of the page and app root around it cannot show
    <Box component="main" sx={{ position: 'fixed', inset: 0, overflow: 'auto', backgroundColor: ColorPalette.ApexTintedLight, fontFamily }}>
      <Typography
        component="h1"
        sx={{
          color: ColorPalette.WHITE,
          backgroundColor: ColorPalette.DeepGalaxy,
          m: 0,
          height: 50,
          lineHeight: '50px',
          px: 2,
          fontSize: 20,
          fontFamily,
        }}
      >
        Logget ud
      </Typography>
      <Box
        sx={{
          maxWidth: 600,
          mx: 'auto',
          my: 5,
          p: '30px',
          backgroundColor: ColorPalette.WHITE,
          borderRadius: 2,
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
        }}
      >
        <Typography sx={{ fontSize: 15, lineHeight: 1.6, color: '#333', fontFamily }}>Du er blevet logget ud af Fasit i et andet vindue.</Typography>
        <Button
          href={`${configuration.baseAddress}/login`}
          fullWidth
          sx={{
            mt: '30px',
            py: 2,
            px: 3,
            color: ColorPalette.WHITE,
            backgroundColor: ColorPalette.CityNightSkies,
            borderRadius: '6px',
            fontSize: 16,
            fontWeight: 500,
            fontFamily,
            textTransform: 'none',
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
            '&:hover': {
              backgroundColor: ColorPalette.CityNightSkiesDark,
              transform: 'translateY(-1px)',
              boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',
            },
          }}
        >
          Log ind igen
        </Button>
      </Box>
    </Box>
  );
}
